import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
    selector: 'app-prompt-option-select',
    templateUrl: './prompt-option-select.component.html',
    styleUrls: ['./prompt-option-select.component.scss'],
    standalone: false
})
export class PromptOptionSelectComponent implements OnInit {
  @Input() icon = '';
  @Input() placeholder = '';
  @Input() options: string[] = [];
  @Input() selectedOption: any;

  @Output() updateSelectedOption = new EventEmitter<any>();

  tooltipString = '';

  ngOnInit() {
    this.tooltipMessage();
  }

  protected tooltipMessage(): void {
    if (this.options.length === 0) {
      this.tooltipString = `No ${this.placeholder.toLowerCase()} available for this prompt`;
    }
    if (this.options.length === 1) {
      this.tooltipString = `Only ${this.selectedOption} is available for this prompt`;
    }
    this.tooltipString = `Change the ${this.placeholder.toLowerCase()}`;
  }

  onSelectionChange(event: any) {
    this.selectedOption = event.value;
    this.updateSelectedOption.emit(this.selectedOption);
  }
}
